// This will auto install plugins
import AttributeDetailCreatorPlugins from "./AttributeDetailCreator.js";
import AttributeColumnCreatorPlugins from "./AttributeColumnCreator.js";
import AttributeExportFieldCreator from "./AttributeExportFieldCreator.js";
import FormatterPlugins from "./formatter/PluginSetup.js";
import I18nResolverPlugins from "./i18nResolver/PluginSetup.js";
import NormalizerPlugins from "./normalizer/PluginSetup.js";
import EditorPlugins from "./editor/PluginSetup.js";
/**
 * Install all the plugins in this directory.
 * @param {object} opts for future use
 */
export default {
  install: opts => {
    AttributeDetailCreatorPlugins.install(opts);
    AttributeColumnCreatorPlugins.install(opts);
    AttributeExportFieldCreator.install(opts);
    FormatterPlugins.install(opts);
    I18nResolverPlugins.install(opts);
    NormalizerPlugins.install(opts);
    EditorPlugins.install(opts);
  }
};